import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { FaCheck } from 'react-icons/fa'
import { getYear } from 'date-fns'

import Yup from '~/services/yup'
import { api } from '~/services/api'

import maskUtils from '~/util/masks'

import ActionFooter from '~/components/ActionFooter'
import { Button, Checkbox, File } from '~/components/Form'
import Modal from '~/components/Modal'

import { Container, TermoContainer, ModalTermoContainer } from './styles'
import { calculaAnuidadeProporcional } from '~/util/valorAnuidade'
import Spinner from '~/components/Spinner'

const initialValues = {
    autorizado: false,
    declaracao: ''
}

const validation = Yup.object({
    autorizado: Yup.boolean(),
    declaracao: Yup.number().nullable().required('Anexe a declaração da Residência Médica')
})

export default function ({ onSubmit }) {
    const [valorAnuidade, setValorAnuidade] = useState(null)
    const [valorDesconto, setValorDesconto] = useState(null)
    const [showTermoCiencia, setShowTermoCiencia] = useState(false)
    const [ano, setAno] = useState(new Date().getFullYear())

    async function loadValores() {
        const response = await api.get('desconto_anuidade', {
            params: { grupo: 'residente' }
        })

        const mensalidade = await api.get(`mensalidade_valor/${new Date().getFullYear()}`)

        if (new Date() > new Date(getYear(new Date()), 5, 30)) {
            const { valorAnuidadeProporcional, competenciaAno } = await calculaAnuidadeProporcional(mensalidade.valor)
            setValorAnuidade(valorAnuidadeProporcional)
            setAno(competenciaAno)
            setValorDesconto(response.desconto)
        } else {
            let valorTotalAnuidade = mensalidade.valor * 12
            if (getYear(new Date()) === 2026) {
                valorTotalAnuidade += 0.10
            }
            setValorAnuidade(valorTotalAnuidade)
            setValorDesconto(response.desconto)
        }
    }

    useEffect(() => {
        loadValores()
    }, [])

    if (!valorAnuidade && !valorDesconto) {
        return <Spinner />
    }

    return (
        <>
            <Container>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validation}
                    onSubmit={onSubmit}
                >
                    {({ isSubmitting, setFieldValue, errors }) => (
                        <Form>
                            <File
                                name="declaracao"
                                id="declaracao_residencia"
                                onSuccess={fileId => setFieldValue('declaracao', fileId)}
                                label="Anexe aqui a Declaração de Residência Médica"
                                format="square"
                                error={errors.declaracao}
                                style={{ width: 'calc(100% - 16px)' }}
                                previewSize={['100%', '140px']}
                            />

                            <>
                                <p style={{ gridArea: 'valor_integral' }}>
                                    Valor da anuidade:
                                    <span style={{ fontWeight: 800 }}>
                                        {valorAnuidade && ` ${maskUtils.maskApply.currency(valorAnuidade)}`}
                                    </span>
                                </p>

                                {valorDesconto && (
                                    <p style={{ gridArea: 'valor_desconto' }}>
                                        {`Desconto de ${valorDesconto}% para médicos residentes:`}
                                        <span style={{ fontWeight: 800 }}>
                                            {valorAnuidade && ` ${maskUtils.maskApply.currency(valorAnuidade / 2)}`}
                                        </span>
                                    </p>
                                )}
                            </>

                            <TermoContainer>
                                <Button onClick={() => setShowTermoCiencia(true)} className="transparent">
                                    VER TERMO DE CIÊNCIA
                                </Button>
                            </TermoContainer>

                            <Checkbox
                                name="autorizado"
                                label={`Li e concordo com o Termo de Ciência acima e autorizo a emissão do boleto da anuidade de ${ano}, no valor correspondente a ${maskUtils.maskApply.currency(valorAnuidade / 2)}, em favor do Sindicato dos Médicos. Estou ciente que este valor será reajustado anualmente no mês de janeiro.`}
                                handleChange={e => { setFieldValue(e.target.name, e.target.checked) }}
                                containerStyle={{ gridArea: 'check' }}
                            />

                            <ActionFooter style={{ gridArea: 'button' }}>
                                <Button type="submit" loading={isSubmitting} className="white">
                                    Concluir
                                    <FaCheck />
                                </Button>
                            </ActionFooter>
                        </Form>
                    )}
                </Formik>
            </Container>

            <Modal
                isOpen={showTermoCiencia}
                handleClose={() => setShowTermoCiencia(false)}
                title="Termo de Ciência do Associado"
            >
                <ModalTermoContainer>
                    <iframe src={`${process.env.REACT_APP_BACKEND_URL}/resources/TERMO DE CIENCIA SINDMEPA.pdf`} frameBorder="0" title="Termo de Ciência" />
                </ModalTermoContainer>
            </Modal>
        </>
    )
}
